"use client";

import { isActivePath } from "@/shared/libs/url-utils";
import Image from "next/image";
import { usePathname } from "next/navigation";
import staticData from "@/public/data/landing.json";
import MobileBanner from "../../../containers/components/layouts/Banner/components/MobileBanner";
import { useDeviceType } from "@/shared/context/DeviceContext";
import type { WebsiteSettings } from "@/types/services/public/apis/Settings";
interface MobileHeaderProps {
  settings: WebsiteSettings;
}
export default function MobileHeader({
  settings
}: MobileHeaderProps) {
  const {
    activePaths
  } = staticData.header;
  const path = usePathname();
  const landingPath = activePaths.includes(path);
  const deviceType = useDeviceType();
  const {
    header_logos
  } = settings.theme;
  if (isActivePath(activePaths, usePathname())) return <MobileBanner className="!h-14">
        {header_logos && <Image src={header_logos} width={200} height={100} alt="logo" className="w-auto h-12 mx-auto" quality={100} />}
      </MobileBanner>;
}